import React, { useState, useEffect } from 'react';
import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import ChatIcon from '@mui/icons-material/Chat';
import BookmarkIcon from '@mui/icons-material/Bookmark';
import NotificationsIcon from '@mui/icons-material/Notifications';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import AddIcon from '@mui/icons-material/Add';
import { useLocation, useNavigate } from 'react-router-dom';
import { Box, Fab, Badge } from '@mui/material';
import { auth, db } from '../firebase';
import { collection, query, where, onSnapshot } from 'firebase/firestore';

const routeToIndex = {
  '/home': 0,
  '/saved-news': 1,
  '/notifications': 3,
  '/profile': 4,
};

function BottomNav() {
  const location = useLocation();
  const navigate = useNavigate();
  const value = routeToIndex[location.pathname] ?? false;
  const [unreadCount, setUnreadCount] = useState(0);

  useEffect(() => {
    const user = auth.currentUser;
    if (!user) return;
    const q = query(
      collection(db, 'notifications'),
      where('userId', '==', user.uid),
      where('read', '==', false)
    );
    const unsub = onSnapshot(q, (snap) => setUnreadCount(snap.size));
    return () => unsub();
  }, []);

  return (
    <Box sx={{ position: 'fixed', bottom: 0, left: 0, width: '100%', zIndex: 1000 }}>
      {/* FAB centrado flotante */}
      <Fab
        onClick={() => navigate('/publish')}
        sx={{
          position: 'absolute',
          top: -28,
          left: '50%',
          transform: 'translateX(-50%)',
          background: 'linear-gradient(135deg, #1976d2, #7c3aed)',
          color: '#fff',
          boxShadow: '0 4px 16px rgba(25,118,210,0.45)',
          '&:hover': { background: 'linear-gradient(135deg, #1565c0, #6d28d9)' },
          width: 52,
          height: 52,
        }}
      >
        <AddIcon sx={{ fontSize: 28 }} />
      </Fab>

      <BottomNavigation
        sx={{ borderTop: '1px solid #e0e0e0', width: '100%' }}
        value={value}
        onChange={(event, newValue) => {
          const routes = ['/home', '/saved-news', null, '/notifications', '/profile'];
          if (routes[newValue]) navigate(routes[newValue]);
        }}
        showLabels
      >
        <BottomNavigationAction label="Chats" icon={<ChatIcon />} />
        <BottomNavigationAction label="Guardadas" icon={<BookmarkIcon />} />
        {/* slot vacío central para darle espacio al FAB */}
        <BottomNavigationAction disabled sx={{ minWidth: 56 }} />
        <BottomNavigationAction
          label="Notificaciones"
          icon={
            <Badge badgeContent={unreadCount} color="error" max={99}>
              <NotificationsIcon />
            </Badge>
          }
        />
        <BottomNavigationAction label="Perfil" icon={<AccountCircleIcon />} />
      </BottomNavigation>
    </Box>
  );
}

export default BottomNav;
